import Storage from '~/util/storage'

const sidebarBreakpointQuery = 'screen and (min-width: 1200px)'

// Safe browser detection for SSR compatibility
const isBrowser = typeof window !== 'undefined' && typeof navigator !== 'undefined'

// Get default locale safely (SSR-compatible)
const getDefaultLocale = () => {
    if (!isBrowser) return 'de'
    const browserLang = navigator.language?.split('-')[0]
    return browserLang === 'de' ? 'de' : 'en'
}

// Get stored locale safely (SSR-compatible)
const getStoredLocale = () => {
    if (!isBrowser) return null
    return window.localStorage.getItem('locale')
}

// Check sidebar state safely (SSR-compatible)
const getSidebarState = () => {
    if (!isBrowser) return false
    return window.matchMedia(sidebarBreakpointQuery).matches
}

export const state = () => {
    return {
        locales: ['de', 'en'],
        locale: getStoredLocale() || getDefaultLocale(),
        sidebarOpen: getSidebarState(),
        validationErrors: [],
        showOnboarding: Storage.get('showOnboarding', true),
    }
}

export const mutations = {
    setLocale(state, payload) {
        // Handle both string locale and user object with preferred_language
        const locale = typeof payload === 'string'
            ? payload
            : payload?.preferred_language

        if (locale && state.locales.includes(locale)) {
            state.locale = locale
            if (isBrowser) {
                window.localStorage.setItem('locale', locale)
            }
            if (this.app?.i18n) {
                this.app.i18n.locale = locale
            }
        }
    },

    setSidebarOpen(state, open) {
        state.sidebarOpen = open
    },

    toggleSidebar(state) {
        state.sidebarOpen = !state.sidebarOpen
    },

    setValidationErrors(state, errors) {
        state.validationErrors = errors
    },

    setShowOnboarding(state, show) {
        state.showOnboarding = show
        Storage.set('showOnboarding', show)
    }
}

export const getters = {

}

export const actions = {
    closeOnSmallDevices({ commit }) {
        if (isBrowser && !window.matchMedia(sidebarBreakpointQuery).matches) {
            commit('setSidebarOpen', false)
        }
    },

    changeLocale({ commit }, locale) {
        commit('setLocale', locale)
    },

    showOnboarding({ commit }) {
        commit('setShowOnboarding', true)
    },

    dismissOnboarding({ commit }) {
        commit('setShowOnboarding', false)
    }
}
